import React from 'react';
import PageSkeletonComponent from '../../components/PageSkeletonComponent/PageSkeletonComponent';
import './SignupType.css';

const SignupType = () => {
  return (
    <PageSkeletonComponent>

     <h1>SIGNUP - Type</h1>

      <hr />

      <h2>Purpose of Page</h2>
      Type page for the signup routine...
      
      <h2>Who Can Access</h2>
      <b>WHO IS EXPECTED TO ACCESS THIS PAGE</b>

    </PageSkeletonComponent>
  );
};

export default SignupType;